export const commitid = 'fe_log_sdk:constants:build:commitid'
export const gitOriginUrl = 'fe_log_sdk:constants:build:gitOriginUrl'